import * as React from "react";
import { observer } from "mobx-react";
import { UitkSelect } from "uitk-react-select";
import { AgeSelectProps, AgeOption } from "../typings";

export const AgeSelect = observer((props: AgeSelectProps) => {
  return (
    <div className="uitk-cell all-cell-1-2">
      <UitkSelect
        label={props.label}
        value={props.guest.age.toString()}
        onChange={props.onChange}
        id={props.id}
      >
        {props.ageOptions.map((option: AgeOption) => (
          <option key={option.value} value={option.value}>
            {option.name}
          </option>
        ))}
      </UitkSelect>
    </div>
  );
});
